import { parsePhoneNumberFromString } from 'libphonenumber-js';
import currency from "currency.js";
import { GLOBAL_CURRENCY } from "constants/appConstants";

export function formatCurrencyNew(value, currencySymbol, precision = 2) {
  const symbol = currencySymbol || GLOBAL_CURRENCY.symbol;
  return currency(value, {
    symbol: `${symbol} `,
    precision: precision,
    separator: ',',
    decimal: '.',
  }).format();
}


export function isValidInternationalPhoneNumber(phoneNumber) {
  if (typeof phoneNumber !== 'string' || phoneNumber.trim() === '') {
    return false;
  }
  const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
  // console.log("phonenumberObj", phoneNumberObj.isValid(),phoneNumber);
  return phoneNumberObj ? phoneNumberObj.isValid() : false;
}



// Turn a category name into a URL-safe slug ("School Wear" -> "school-wear")
// so a category selection can live in the path and be shared / linked from a CMS.
export function slugifyCategory(name) {
  return (name || "")
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Resolve a slug from the URL back to the real category name using the loaded
// category list. Falls back to a de-slugged guess while categories are still
// loading so a hard load / shared link still applies the filter immediately.
export function resolveCategorySlug(categories, slug) {
  if (!slug) return undefined;
  const match =
    Array.isArray(categories) &&
    categories.find((cat) => slugifyCategory(cat?.name) === slug);
  return match ? match.name : slug.replace(/-/g, " ");
}


//  const webDetails = useSelector(state => state.webDetails);
//     const { websiteInfo } = webDetails;


// for store offline or online
//  const webDetails = useSelector(state => state.webDetails);
//     const { websiteInfo } = webDetails;
//     websiteInfo?.whatsapp_status